<template>
  <div class="yxtbiz-o2o-multi-evaluate-dialog">
    <yxtf-dialog
      :visible.sync="showDialog"
      :close-on-click-modal="false"
      :show-close="false"
      width="520px"
      append-to-body
      modal-append-to-body
      :cutline="false">
      <div class="yxtbiz-o2o-multi-evaluate-dialog__content">
        <yxtf-svg width="88px" height="88px" icon-class="biz/result-success-icon" />
        <div class="standard-size-20 yxt-weight-5 mt16 color-gray-10">{{$t('pc_biz_o2o_submitsuccesss'/**提交成功 */)}}</div>
        <div v-if="countDownFlag" class="color-gray-8 mt12">{{message}}</div>
        <div class="mt32">
          <template v-if="hasNext">
            <yxtf-button :type="mergeFlag ? '': 'primary'" @click="toDetail">{{$t('pc_biz_o2o_viewresult'/**pc_biz_o2o_viewresult */)}}</yxtf-button>
            <yxtf-button v-if="mergeFlag" type="primary" @click="toNext">{{$t('pc_biz_o2o_nextimmediate'/**立即跳转下一个 */)}}</yxtf-button>
          </template>
          <yxtf-button v-else type="primary" @click="toDetail">{{$t('pc_biz_o2o_viewresult'/**pc_biz_o2o_viewresult */)}}</yxtf-button>
        </div>
      </div>
    </yxtf-dialog>
  </div>
</template>

<script>
import { getSimpleProjectInfo, getTaskInfo } from '../service';
import utils from 'yxt-biz-pc/packages/common-util/utils';
import { Loading } from 'yxt-pc';
export default {
  name: 'YxtbizO2oMultiEvaluateDialog',
  name_zh: '合并评价弹窗',
  data() {
    return {
      showDialog: true,
      hasNext: false,
      message: '',
      countdown: this.interval,
      nextOption: {},
      otherOption: {},
      mergeFlag: false,
      countDownFlag: false
    };
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
      desc: '是否显示弹窗',
      setter: 'BooleanSetter'
    },
    interval: {
      type: Number,
      default: 5,
      desc: '倒计时长度/秒',
      setter: 'NumberSetter'
    },
    projectId: {
      type: String,
      default: '',
      desc: '项目id',
      setter: 'StringSetter'
    },
    defaultTaskId: {
      type: String,
      default: '',
      desc: '当前评价任务id',
      setter: 'StringSetter'
    }
  },
  created() {
    this.getProjectInfo();
  },
  watch: {
    visible: {
      immediate: true,
      handler(val) {
        if (val) {
          this.openLoading();
        } else {
          this.showDialog = val;
          this.endTimer();
        }
      }
    },
    showDialog(val) {
      this.$emit('update:visible', val);
    }
  },
  methods: {
    getProjectInfo() {
      const projectId = utils.getQueryString('mergeEvalProjectId') || this.projectId;
      getSimpleProjectInfo(projectId).then(res => {
        this.mergeFlag = res.allowSurveyMerging;
        this.countDownFlag = res.allowSurveyMerging ? res.allowAutoJumpNextSurvey : 0;
      });
    },
    openLoading() {
      this.loadingInstance = Loading.service({
        fullscreen: true,
        lock: true,
        text: this.$t('pc_biz_o2o_submiting' /** 提交中 */)
      });
      setTimeout(() => {
        this.loadingInstance.close();
        this.getNextInfo();
      }, 1000);
    },
    async getNextInfo() {
      this.hasNext = false;
      const currentTaskId = utils.getQueryString('mergeEvalTaskId') || this.defaultTaskId;
      const projectId = utils.getQueryString('mergeEvalProjectId') || this.projectId;
      this.otherOption = { mergeEvalProjectId: projectId };
      if (currentTaskId && projectId) {
        try {
          const res = await getTaskInfo({ currentTaskId, projectId });
          // 根据taskId查询taskInfo
          if (res) {
            this.initNextOption(res);
            this.hasNext = true;
          }
        } catch (e) {
          console.log(e);
        }
      }
      if (this.hasNext) {
        if (this.countDownFlag) {
          this.countdown = this.interval;
          this.setMessage();
          this.startTimer();
        }
      } else {
        this.message = this.$t('pc_biz_o2o_completeallevaluate'/** 太棒了，你已提交完成当前所有问卷*/);
      }
      this.showDialog = true;
    },
    initNextOption(info) {
      // taskOwner 1学员导师评价 2学员自评
      // type 4 评价任务
      const id = info.taskType === 4 && (info.taskOwner === 1 || info.taskOwner === 2) ? info.evalCfgId : (info.taskType === 1 ? info.targetId : info.taskId);
      // const tid = info.taskOwner === 1 ? (info.teacherId || teid) : localStorage.userId
      const tid = info.taskOwner === 1 ? info.teacherId : info.userId;
      this.nextOption = {
        type: 2,
        id,
        tid,
        tname: ''
      };
      this.otherOption.mergeEvalTaskId = info.taskId;
    },
    startTimer() {
      if (!this.timer) {
        this.timer = setInterval(() => {
          this.countdown--;
          this.setMessage();
          if (this.countdown === 0) {
            this.endTimer();
            this.toNext();
          }
        }, 1000);
      }
    },
    endTimer() {
      this.timer && window.clearInterval(this.timer);
      this.timer = null;
    },
    setMessage() {
      this.message = this.$t('pc_biz_o2o_nextsecond', [this.countdown]); // s 后即将自动跳转下一份问卷作答
    },
    toNext() {
      if (this.hasNext) this.$emit('next', this.nextOption, this.otherOption);
      else this.toDetail();
      this.showDialog = false;
    },
    toDetail() {
      this.$emit('detail');
      this.showDialog = false;
    }
  }
};
</script>
